import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonImg,
  IonPage,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { GetFilteredExercises } from "../services/ExercisesService";
import {
  allExercisesState,
  duplicateExercisePlanState,
  fixedAllExercisesState,
  lookupDetailsState,
  tempAllExercisesState,
} from "../data/atoms";
import { useRecoilState } from "recoil";
import { sortTests } from "../utils/sharedFunction";

interface Props {
  exercisesLookupDetails: any;
  filteredExercisesList: Function;
  handleClose: Function;
  setIsFilterSelected: Function;
}

const ExerciseFilterOptions: React.FC<Props> = ({
  exercisesLookupDetails,
  filteredExercisesList,
  handleClose,
  setIsFilterSelected,
}) => {
  const [lookupDetailsRecoil, setLookupDetailsRecoil] =
    useRecoilState(lookupDetailsState);
  const [LookupDetails, setLookupDetails] = useState<any>(lookupDetailsRecoil);
  const [allExercisesFilter, setAllExercisesFilterState] =
    useRecoilState(allExercisesState);
  const [filteredLookupDetails, setFilteredLookupDetails] = useState<any[]>([]);
  const [selectedAccordion, setSelectedAccordion] = useState<any>({
    regions: true,
    positions: false,
    types: false,
    assessmentAssociated: false,
    mobilityLevel: false,
  });
  const [fixedExercisesCount, setFixedExercisesCount] = useRecoilState(
    fixedAllExercisesState
  );
  const [isFilterEmpty, setIsFilterEmpty] = useState(false);

  const [tempAllExercises, setTempAllExercises] = useRecoilState(
    tempAllExercisesState
  );
  const [previousExercise, setPreviousExercise] = useRecoilState(
    duplicateExercisePlanState
  );

  const checkFilter = (data: any) => {
    debugger;
    console.log("checkFilterdata", data);
    if (data?.some((temp: any) => temp.isSelected)) {
      setIsFilterEmpty(true);
    } else {
      setIsFilterEmpty(false);
    }
  };

  const handleAccordionChange = (value: string) => {
    if (value === "regions") {
      setSelectedAccordion((prevState: any) => ({
        ...prevState,
        regions: !prevState.regions,
      }));
    } else if (value === "positions") {
      setSelectedAccordion((prevState: any) => ({
        ...prevState,
        positions: !prevState.positions,
      }));
    } else if (value === "types") {
      setSelectedAccordion((prevState: any) => ({
        ...prevState,
        types: !prevState.types,
      }));
    } else if (value === "assessmentAssociated") {
      setSelectedAccordion((prevState: any) => ({
        ...prevState,
        assessmentAssociated: !prevState.assessmentAssociated,
      }));
    } else if (value === "mobilityLevel") {
      setSelectedAccordion((prevState: any) => ({
        ...prevState,
        mobilityLevel: !prevState.mobilityLevel,
      }));
    }
  };

  useEffect(() => {
    if (filteredLookupDetails.length > 0) {
      setIsFilterEmpty(true);
    }
  }, [filteredLookupDetails]);

  useEffect(() => {
    setFilteredLookupDetails([]);

    const iterateThroughRecoilObject = (obj: any) => {
      Object.keys(obj).forEach((key) => {
        const value = obj[key];
        if (Array.isArray(value)) {
          value.forEach((item: any) => {
            if (item.isSelected) {
              setFilteredLookupDetails((prevState) => [...prevState, item]);
            }
          });
        }
      });
    };

    iterateThroughRecoilObject(LookupDetails);
  }, [LookupDetails]);

  const handleFilterClick = (item: any, type: any) => {
    let updatedData: any = [];

    if (type == "regions") {
      updatedData = LookupDetails?.regions.map((r: any) =>
        r.name === item.name ? { ...r, isSelected: !r.isSelected } : r
      );
    } else if (type == "positions") {
      updatedData = LookupDetails?.positions.map((r: any) =>
        r.name === item.name ? { ...r, isSelected: !r.isSelected } : r
      );
    } else if (type == "types") {
      updatedData = LookupDetails?.types.map((r: any) =>
        r.name === item.name ? { ...r, isSelected: !r.isSelected } : r
      );
    } else if (type == "assessmentAssociated") {
      updatedData = LookupDetails?.assessmentAssociated.map((r: any) =>
        r.name === item.name ? { ...r, isSelected: !r.isSelected } : r
      );
    } else if (type == "mobilityLevel") {
      updatedData = LookupDetails?.mobilityLevel.map((r: any) =>
        r.name === item.name ? { ...r, isSelected: !r.isSelected } : r
      );
    }

    setLookupDetails((prevDetails: any) => ({
      ...prevDetails,
      [type]: updatedData,
    }));

    checkFilter(updatedData);
  };

  const filterExercises = async () => {
    // Object containing the selected filters
    let obj = {
      regions: LookupDetails?.regions.filter((r: any) => r.isSelected),
      positions: LookupDetails?.positions.filter((r: any) => r.isSelected),
      types: LookupDetails?.types.filter((r: any) => r.isSelected),
      assessmentAssociated: LookupDetails?.assessmentAssociated.filter(
        (r: any) => r.isSelected
      ),
      mobilityLevel: LookupDetails?.mobilityLevel.filter(
        (r: any) => r.isSelected
      ),
    };
    let extractedIds = extractIdsFromFilters(obj);
    console.log("extractedIds", extractedIds);
    filteredExercisesList(extractedIds);
    await getFilteredExercises(extractedIds);
    setLookupDetailsRecoil(LookupDetails);
    handleClose();
  };

  const clearFilterExercises = async () => {
    // Object containing the selected filters
    let obj = {
      regions: LookupDetails?.regions.map((r: any) => ({
        ...r,
        isSelected: false,
      })),
      positions: LookupDetails?.positions.map((r: any) => ({
        ...r,
        isSelected: false,
      })),
      types: LookupDetails?.types.map((r: any) => ({
        ...r,
        isSelected: false,
      })),
      assessmentAssociated: LookupDetails?.assessmentAssociated.map(
        (r: any) => ({
          ...r,
          isSelected: false,
        })
      ),
      mobilityLevel: LookupDetails?.mobilityLevel.map((r: any) => ({
        ...r,
        isSelected: false,
      })),
    };
    let idObj = {
      regions: obj.regions.filter((r: any) => r.isSelected),
      positions: obj.positions.filter((r: any) => r.isSelected),
      types: obj.types.filter((r: any) => r.isSelected),
      assessmentAssociated: obj.assessmentAssociated.filter(
        (r: any) => r.isSelected
      ),
      mobilityLevel: obj.mobilityLevel.filter((r: any) => r.isSelected),
    };
    let extractedIds = extractIdsFromFilters(idObj);
    filteredExercisesList(extractedIds);
    setLookupDetails((prevState: any) => ({
      ...prevState,
      regions: obj.regions,
      positions: obj.positions,
      types: obj.types,
      assessmentAssociated: obj.assessmentAssociated,
      mobilityLevel: obj.mobilityLevel,
    }));
    setLookupDetailsRecoil((prevState: any) => ({
      ...prevState,
      regions: obj.regions,
      positions: obj.positions,
      types: obj.types,
      assessmentAssociated: obj.assessmentAssociated,
      mobilityLevel: obj.mobilityLevel,
    }));

    // Clone the array to avoid mutating state directly
    const clonedArr: any = [...fixedExercisesCount.exercises];

    //take out the ids from previousExercise
    let selectedIds = previousExercise.exercises.map(
      (exercise: any) => exercise.testExercises[0].id
    );

    console.log("selectedIds", selectedIds);

    const sortArr = sortTests(clonedArr, selectedIds);

    console.log("sortArr", sortArr);

    setTempAllExercises((prevState: any) => ({
      ...prevState,
      exercises: sortArr,
    }));

    setAllExercisesFilterState((prevState: any) => ({
      ...prevState,
      exercises: fixedExercisesCount.exercises,
      exercisesRecommendationHistory:
        fixedExercisesCount.exercisesRecommendationHistory,
      recommendedExercisesBasedOnAssessment:
        fixedExercisesCount.recommendedExercisesBasedOnAssessment,
      sidesLookup: fixedExercisesCount.sidesLookup,
      patientDetails: fixedExercisesCount.patientDetails,
      previouslySelectedExercises:
        fixedExercisesCount.previouslySelectedExercises,
    }));
    setIsFilterSelected(false);
    handleClose();
  };

  //Functions to extract the ids from the selected filters
  const extractIdsFromFilters = (data: any) => {
    let idsByKey: any = {};
    idsByKey.regionId = data.regions.map((item: any) => item.id).join(",");
    idsByKey.positionsId = data.positions.map((item: any) => item.id).join(",");
    idsByKey.typesId = data.types.map((item: any) => item.id).join(",");
    idsByKey.assessmentAssociatedId = data.assessmentAssociated
      .map((item: any) => item.id)
      .join(",");
    idsByKey.mobilityLevelId = data.mobilityLevel
      .map((item: any) => item.id)
      .join(",");
    console.log("idsByKey", idsByKey);
    if (
      idsByKey.regionId !== "" ||
      idsByKey.positionsId !== "" ||
      idsByKey.typesId !== "" ||
      idsByKey.assessmentAssociatedId !== "" ||
      idsByKey.mobilityLevelId !== ""
    ) {
      setIsFilterSelected(true);
    }
    return idsByKey;
  };

  const getFilteredExercises = async (ids: any) => {
    const obj = {
      PatientId: localStorage.getItem("patientServerID")!,
      FiltersValuesRegions: ids.regionId,
      FiltersValuesPositions: ids.positionsId,
      FiltersValuesTypes: ids.typesId,
      FiltersValuesAssessmentsAssociated: ids.assessmentAssociatedId,
      FiltersValuesMobilityLevel: ids.mobilityLevelId,
      SearchedExerciseName: "",
      ExercisesIds: "",
    };
    try {
      await GetFilteredExercises(obj)
        .then(async function (response: any) {
          const responseExercises = response.data.allExercisesList;
          // Extracting IDs from responseExercises
          const responseExerciseIds = responseExercises.map(
            (exercise: any) => exercise.testExercises[0].id
          );

          // Filtering fixedExercisesCount.exercises based on the extracted IDs
          const filteredExerciseList = fixedExercisesCount.exercises.filter(
            (fixedExercise: any) =>
              responseExerciseIds.includes(fixedExercise.testExercises[0].id)
          );

          setTempAllExercises((prevState: any) => ({
            ...prevState,
            exercises: filteredExerciseList,
          }));

          setAllExercisesFilterState((prevState: any) => ({
            ...prevState,
            exercises: filteredExerciseList,
            exercisesRecommendationHistory:
              fixedExercisesCount.exercisesRecommendationHistory,
            recommendedExercisesBasedOnAssessment:
              fixedExercisesCount.recommendedExercisesBasedOnAssessment,
            sidesLookup: fixedExercisesCount.sidesLookup,
            patientDetails: fixedExercisesCount.patientDetails,
            previouslySelectedExercises:
              fixedExercisesCount.previouslySelectedExercises,
          }));
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <IonPage placeholder={undefined} className="edit-exercise-modal">
      <IonHeader placeholder={undefined} className="main-header-sec">
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row align-items-center" placeholder={undefined}>
            <IonCol className="col-sec" size="2" placeholder={undefined}>
              <div
                className="cross-icon-wrap"
                onClick={() => {
                  handleClose();
                }}
              >
                <svg
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.43934 0.834112C1.02513 0.200661 1.97487 0.200661 2.56066 0.834112L13.5606 12.729C14.1463 13.3625 14.1463 14.3895 13.5606 15.023C12.9748 15.6564 12.025 15.6564 11.4392 15.023L0.43934 3.12804C-0.146447 2.49459 -0.146447 1.46756 0.43934 0.834112Z"
                    fill="#31344E"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.5606 0.834112C14.1464 1.46756 14.1464 2.49459 13.5606 3.12804L2.56066 15.023C1.97487 15.6565 1.02513 15.6565 0.43934 15.023C-0.146447 14.3896 -0.146447 13.3626 0.43934 12.7291L11.4393 0.834112C12.0251 0.200661 12.9748 0.200661 13.5606 0.834112Z"
                    fill="#31344E"
                  />
                </svg>
              </div>
            </IonCol>
            <IonCol className="col-sec" size="8" placeholder={undefined}>
              <div className="header-tile-sec text-center">
                <h1>Filters</h1>
              </div>
            </IonCol>
            <IonCol
              className="col-sec"
              size="2"
              placeholder={undefined}
            ></IonCol>
          </IonRow>
        </IonGrid>
      </IonHeader>
      <IonContent placeholder={undefined}>
        <div className="exercise-filter-main-wrap">
          <div className="filter-accordian-main-wrap">
            <div
              className="filter-accordian-header-wrap"
              onClick={() => handleAccordionChange("regions")}
            >
              <div className="filter-accordian-header">Regions</div>
              {!selectedAccordion?.regions ? (
                <div className="toggleIconOpen">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 5.5L9 11.5L3 5.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              ) : (
                <div className="toggleIconClose">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 12.5L9 6.5L15 12.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div
              slot="content"
              className={`filter-accordian-body ${
                !selectedAccordion?.regions && "d-none"
              }`}
            >
              <ul>
                {LookupDetails?.regions.map((region: any, index: number) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleFilterClick(region, "regions");
                    }}
                  >
                    <span className={region.isSelected ? "active" : ""}>
                      <IonImg
                        src={`Images/${region.name}.png`}
                        alt={region.name}
                        placeholder={undefined}
                      ></IonImg>
                      <h6>{region.name}</h6>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="filter-accordian-main-wrap">
            <div
              className="filter-accordian-header-wrap"
              onClick={() => {
                handleAccordionChange("positions");
              }}
            >
              <div className="filter-accordian-header">Positions</div>
              {!selectedAccordion?.positions ? (
                <div className="toggleIconOpen">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 5.5L9 11.5L3 5.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              ) : (
                <div className="toggleIconClose">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 12.5L9 6.5L15 12.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div
              slot="content"
              className={`filter-accordian-body ${
                !selectedAccordion?.positions && "d-none"
              }`}
            >
              <ul>
                {LookupDetails?.positions.map(
                  (position: any, index: number) => (
                    <li
                      key={index}
                      onClick={() => {
                        handleFilterClick(position, "positions");
                      }}
                    >
                      <span className={position.isSelected ? "active" : ""}>
                        <IonImg
                          src={`Images/${position.name}.png`}
                          alt={position.name}
                          placeholder={undefined}
                        ></IonImg>
                        <h6>{position.name}</h6>
                      </span>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
          <div className="filter-accordian-main-wrap">
            <div
              className="filter-accordian-header-wrap"
              onClick={() => {
                handleAccordionChange("types");
              }}
            >
              <div className="filter-accordian-header">Type</div>
              {!selectedAccordion?.types ? (
                <div className="toggleIconOpen">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 5.5L9 11.5L3 5.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              ) : (
                <div className="toggleIconClose">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 12.5L9 6.5L15 12.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div
              slot="content"
              className={`filter-accordian-body ${
                !selectedAccordion?.types && "d-none"
              }`}
            >
              <ul>
                {LookupDetails?.types.map((type: any, index: number) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleFilterClick(type, "types");
                    }}
                  >
                    <span className={type.isSelected ? "active" : ""}>
                      <IonImg
                        src={`Images/${type.name}.png`}
                        alt={type.name}
                        placeholder={undefined}
                      ></IonImg>
                      <h6>{type.name}</h6>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="filter-accordian-main-wrap">
            <div
              className="filter-accordian-header-wrap"
              onClick={() => {
                handleAccordionChange("assessmentAssociated");
              }}
            >
              <div className="filter-accordian-header">
                Assessment Associated
              </div>
              {!selectedAccordion?.assessmentAssociated ? (
                <div className="toggleIconOpen">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 5.5L9 11.5L3 5.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              ) : (
                <div className="toggleIconClose">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 12.5L9 6.5L15 12.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div
              slot="content"
              className={`filter-accordian-body ${
                !selectedAccordion?.assessmentAssociated && "d-none"
              }`}
            >
              <ul>
                {LookupDetails?.assessmentAssociated.map(
                  (assesement: any, index: number) => (
                    <li
                      key={index}
                      onClick={() => {
                        handleFilterClick(assesement, "assessmentAssociated");
                      }}
                    >
                      <span className={assesement.isSelected ? "active" : ""}>
                        <IonImg
                          src={`Images/${assesement.name}.png`}
                          alt={assesement.name}
                          placeholder={undefined}
                        ></IonImg>
                        <h6>
                          {assesement.name == "Gait Test"
                            ? "Gait"
                            : assesement.name}
                        </h6>
                      </span>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
          <div className="filter-accordian-main-wrap">
            <div
              className="filter-accordian-header-wrap"
              onClick={() => {
                handleAccordionChange("mobilityLevel");
              }}
            >
              <div className="filter-accordian-header">Mobility Level</div>
              {!selectedAccordion?.mobilityLevel ? (
                <div className="toggleIconOpen">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 5.5L9 11.5L3 5.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              ) : (
                <div className="toggleIconClose">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 12.5L9 6.5L15 12.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div
              slot="content"
              className={`filter-accordian-body ${
                !selectedAccordion?.mobilityLevel && "d-none"
              }`}
            >
              <ul>
                {LookupDetails?.mobilityLevel.map(
                  (mobility: any, index: number) => (
                    <li
                      key={index}
                      onClick={() => {
                        handleFilterClick(mobility, "mobilityLevel");
                      }}
                    >
                      <span className={mobility.isSelected ? "active" : ""}>
                        <IonImg
                          src={`Images/${mobility.name}.png`}
                          alt={mobility.name}
                          placeholder={undefined}
                        ></IonImg>
                        <h6>{mobility.name}</h6>
                      </span>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </div>
      </IonContent>
      {isFilterEmpty && (
        <IonFooter
          className="ion-no-border duplicate-ex-page-footer"
          placeholder={undefined}
        >
          <IonGrid className="container" placeholder={undefined}>
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="two-col-btn">
                  <IonButton
                    placeholder={undefined}
                    className="blue-outline-btn"
                    onClick={() => {
                      clearFilterExercises();
                    }}
                  >
                    Clear
                  </IonButton>
                  <IonButton
                    placeholder={undefined}
                    className="blue-btn"
                    onClick={() => {
                      filterExercises();
                    }}
                  >
                    Apply
                    {filteredLookupDetails.length > 0
                      ? ` ${filteredLookupDetails.length} `
                      : " "}
                    Filters
                  </IonButton>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonFooter>
      )}
    </IonPage>
  );
};

export default ExerciseFilterOptions;
